// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__3tee0","question":"Question_question__o51Kd","description":"Question_description__2NS7y"};